export function HotStreakIcon() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 48 48"
      fill="none"
      stroke="currentColor"
      strokeWidth="2.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M24 6c0 8-10 12-10 22a14 14 0 0028 0c0-10-10-14-10-22" />
      <path d="M20 32c0-4 4-6 4-10 0 4 4 6 4 10a4 4 0 01-8 0" />
    </svg>
  );
}
